'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ForecastArticleCard = require('./ForecastArticleCard');

var _ForecastArticleCard2 = _interopRequireDefault(_ForecastArticleCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForecastArticleCard2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecastArticleCard/index.js
// module id = 583
// module chunks = 11